import { createFileRoute } from '@tanstack/react-router'
import {
  DownloadHeroSection,
  DownloadOptionsSection,
  DownloadInstructionsSection,
  PricingSection,
  FaqSection,
  ContactSection,
} from '../sections'

/**
 * Downloads page route.
 * Renders the CMS `downloads` page with device-aware CTAs, install instructions,
 * pricing, FAQ and contact.
 */
export const Route = createFileRoute('/downloads')({
  component: DownloadsPage,
})

function DownloadsPage() {
  return (
    <div className="flex flex-col">
      <DownloadHeroSection />
      <DownloadOptionsSection />
      <DownloadInstructionsSection />
      <PricingSection />
      <FaqSection category="Download" />
      <ContactSection />
    </div>
  )
}
